export const enum STATES {
  READY = 'ready',
}

export const enum ACTIONS {
  SET_CONNECTION = 'setConnection',
}

export const enum EVENTS {
  CONNECTION_CHANGED = 'CONNECTION_CHANGED',
}
